module.exports = __webpack_public_path__ + "static/media/addCalander.73d5a21e.svg";